// Wybór wyglądu PDF (raport, CL, FUL): v1 obecny, v2 (kolor), v2 uproszczony.
// Od 05.11 (feedback klienta): zawsze domyślnie klasyczny, bez zapamiętywania wyboru; v2 z ostrzeżeniem,
// bo nowy wzór nie jest jeszcze zaakceptowany.
import { useState } from "react";
import type { DesignVariant } from "../../pages/report/document/v2/pdfV2Kit";

export type PdfDesign = "v1" | "v2" | "v2s";

// Dawniej zapamiętany wybór; czyszczony, żeby nie wracał po starej wersji
const OLD_STORAGE_KEY = "reportPdfDesign";
export const PDF_DESIGNS: [PdfDesign, string][] = [
  ["v1", "Klasyczny (v1)"],
  ["v2", "Nowy (v2)"],
  ["v2s", "Nowy uproszczony (v2)"],
];

export const PDF_V2_WARNING = "Nowy wygląd nie jest jeszcze zaakceptowanym wzorem. Dokumenty dla sponsora generuj w wyglądzie klasycznym.";

// null = wygląd klasyczny (generator v1)
export const toVariant = (d: PdfDesign): DesignVariant | null => (d === "v2" ? "color" : d === "v2s" ? "simple" : null);

export const usePdfDesign = (): [PdfDesign, (d: PdfDesign) => void] => {
  const [design, setDesign] = useState<PdfDesign>(() => {
    try {
      localStorage.removeItem(OLD_STORAGE_KEY);
    } catch {}
    return "v1";
  });
  return [design, setDesign];
};

export const PdfDesignPicker = ({ value, onChange, name }: { value: PdfDesign; onChange: (d: PdfDesign) => void; name: string }) => (
  <div>
    <div className="px-2 pb-1 text-[10px] font-medium uppercase tracking-[0.08em] text-[var(--sc-muted)]">Wygląd</div>
    {PDF_DESIGNS.map(([v, label]) => (
      <label key={v} className="flex items-center gap-2 px-2 py-1 text-[11px] text-[var(--sc-muted)] cursor-pointer rounded-[6px] hover:bg-[var(--sc-bg)]">
        <input type="radio" name={name} checked={value === v} onChange={() => onChange(v)} className="accent-[#F4A832]" />
        {label}
      </label>
    ))}
    {value !== "v1" && (
      <div role="alert" className="mx-2 mt-1 rounded-[6px] border border-[#F5D98A] bg-[#FFFBEB] px-2 py-1.5 text-[11px] leading-snug text-[#92620A]">
        ⚠️ {PDF_V2_WARNING}
      </div>
    )}
  </div>
);
